import React, { useEffect } from 'react';
import Router from "./router/Router";
import { useLocation, useNavigate } from 'react-router-dom';
import useModalStore from './zustand/store/useModalStore';
import { useShallow } from 'zustand/shallow';
import ConfirmModal from './component/common/modal/ConfirmModal';

import { useDynamicStyle } from './hooks/useDynamicStyle';
import { registerAuthExitNavigator } from './component/AxiosCORS';

function Layout() {
    
    const location = useLocation();
    const navigate = useNavigate();

    // 전역 axios 인터셉터가 401 을 받았을 때 SPA 라우팅으로 로그인 화면으로 보내게 한다.
    // Layout 은 Router 를 감싸고 있어 항상 마운트돼 있으므로 여기서 등록하는 것이 안전하다.
    useEffect(() => {
        registerAuthExitNavigator(navigate);
    }, [navigate]);
    const isMemberPath = location.pathname.startsWith('/member/');

    // modal open function
    const [notiModal, confirmModal, promptModal] = useModalStore(
        useShallow((state) => [state.notiModal, state.confirmModal, state.promptModal]));

    // Dynamic Style Hook
    const { backColor } = useDynamicStyle();

    return (
        <React.Fragment>
            <div className={isMemberPath ? '' : `flex overflow-hidden ${backColor}`}>
                {!(notiModal || confirmModal || promptModal) ? '' : <ConfirmModal />}
                <Router/>
            </div>
        </React.Fragment>
    );
}

export default Layout;
